import { forwardRef } from "react";
import { Turnstile, TurnstileInstance } from "@marsidev/react-turnstile";
import { useTurnstileSiteKey } from "@/hooks/useTurnstileSiteKey";
import { useTheme } from "next-themes";

interface CaptchaWidgetProps {
  onVerify: (token: string) => void;
  onExpire?: () => void;
}

export const CaptchaWidget = forwardRef<TurnstileInstance, CaptchaWidgetProps>(
  ({ onVerify, onExpire }, ref) => {
    const siteKey = useTurnstileSiteKey();
    const { resolvedTheme } = useTheme();

    if (!siteKey) return null;

    return (
      <div className="flex justify-center">
        <Turnstile
          ref={ref}
          siteKey={siteKey}
          onSuccess={onVerify}
          onExpire={() => {
            onVerify("");
            onExpire?.();
          }}
          options={{
            theme: resolvedTheme === "dark" ? "dark" : "light",
            size: "flexible",
          }}
        />
      </div>
    );
  }
);
CaptchaWidget.displayName = "CaptchaWidget";
